module.exports = __webpack_public_path__ + "img/online-course.0208b5bb.png";